import { UserSettings } from '../../Types';

export const SET_USER_ROLES = 'SET_USER_ROLES';
export const SET_USER_IS_ADMIN = 'SET_USER_IS_ADMIN';
export const SET_USER_IS_SUPER_ADMIN = 'SET_USER_IS_SUPER_ADMIN';
export const SET_USER_IS_AVENCY = 'SET_USER_IS_AVENCY';
export const SET_USER_EMAIL = 'SET_USER_EMAIL';
export const SET_USER_GIVEN_NAME = 'SET_USER_GIVEN_NAME';
export const SET_USER_FAMILY_NAME = 'SET_USER_FAMILY_NAME';
export const SET_USER_IMAGE = 'SET_USER_IMAGE';
export const SET_USER_ACCESS_TOKEN = 'SET_USER_ACCESS_TOKEN';
export const SET_EXPIRES_AT = 'SET_EXPIRES_AT';
export const SET_USER_IS_LOGGED_IN = 'SET_USER_IS_LOGGED_IN';
export const SET_USER_AVAILABLE_DEMO_AMOUNT = 'SET_USER_AVAILABLE_DEMO_AMOUNT';
export const SET_USER_AVAILABLE_DEMO_AMOUNT_FORMATTED = 'SET_USER_AVAILABLE_DEMO_AMOUNT_FORMATTED';
export const SET_USER_SETTINGS = 'SET_USER_SETTINGS';
export const SET_USERKEY = 'SET_USERKEY';
export const SET_LAST_CHANGELOG_HASH = 'SET_LAST_CHANGELOG_HASH';

export function setUserSettings(settings: UserSettings) {
    return { type: SET_USER_SETTINGS, payload: settings };
}

export function setUserkey(key: UserSettings['userkey']) {
    return { type: SET_USERKEY, payload: key };
}

export function setUserRoles(roles: UserSettings['roles']) {
    return { type: SET_USER_ROLES, payload: roles };
}

export function setUserIsAdmin(isAdmin: UserSettings['isAdmin']) {
    return { type: SET_USER_IS_ADMIN, payload: isAdmin };
}

export function setUserIsSuperAdmin(isSuperAdmin: UserSettings['isSuperAdmin']) {
    return { type: SET_USER_IS_SUPER_ADMIN, payload: isSuperAdmin };
}

export function setUserIsAvency(isAvency: UserSettings['isAvency']) {
    return { type: SET_USER_IS_AVENCY, payload: isAvency };
}

export function setUserEmail(email: UserSettings['email']) {
    return { type: SET_USER_EMAIL, payload: email };
}

export function setUserGivenName(givenName: UserSettings['givenName']) {
    return { type: SET_USER_GIVEN_NAME, payload: givenName };
}

export function setUserFamilyName(familyName: UserSettings['familyName']) {
    return { type: SET_USER_FAMILY_NAME, payload: familyName };
}

export function setUserImage(image: UserSettings['image']) {
    return { type: SET_USER_IMAGE, payload: image };
}

export function setUserAccessToken(accessToken: UserSettings['accessToken']) {
    return { type: SET_USER_ACCESS_TOKEN, payload: accessToken };
}

export function setUserExpiresAt(expiresAt: UserSettings['expiresAt']) {
    return { type: SET_EXPIRES_AT, payload: expiresAt };
}

export function setUserIsLoggedIn(isLoggedIn: UserSettings['isLoggedIn']) {
    return { type: SET_USER_IS_LOGGED_IN, payload: isLoggedIn };
}

export function setUserAvailableDemoAmount(amount: UserSettings['availableDemoAmount']) {
    return { type: SET_USER_AVAILABLE_DEMO_AMOUNT, payload: amount };
}

export function setUserAvailableDemoAmountFormatted(amount: UserSettings['availableDemoAmountFormatted']) {
    return { type: SET_USER_AVAILABLE_DEMO_AMOUNT_FORMATTED, payload: amount };
}

export function setLastChangelogHash(hash: UserSettings['lastChangelogHash']) {
    return { type: SET_LAST_CHANGELOG_HASH, payload: hash };
}
